import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Boxes, Users, BookOpen, ArrowRight } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export default function InstructorGroups() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [groups, setGroups] = useState(null);

  useEffect(() => {
    api.get("/groups").then((r) => setGroups(r.data)).catch(() => setGroups([]));
  }, []);

  const totalStudents = (groups || []).reduce((a, g) => a + (g.student_count || 0), 0);

  return (
    <div className="space-y-6 animate-fade-up">
      {/* mesma faixa da aluna e da Sala do Professor (frascos + modelo com os produtos) */}
      <div className="aluna-hero relative rounded-3xl overflow-hidden">
        <img src="/brand/login-arte-frascos.webp" alt="" className="aluna-hero-frascos" />
        <img src="/brand/aluna-hero-arte.webp" alt="" className="aluna-hero-mulher" />
        <div className="relative px-6 py-7 sm:py-10 sm:pl-[118px] sm:pr-10 max-w-2xl">
          <p className="text-[#1E9E2A] text-sm font-bold">Olá, {user?.name?.split(" ")[0]} 👋</p>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-[#1A2340] mt-1">Minhas turmas</h1>
          <p className="text-slate-600 mt-2"><b className="text-[#1A2340]">{(groups || []).length}</b> turma(s) · <b className="text-[#1A2340]">{totalStudents.toLocaleString("pt-BR")}</b> aluno(s)</p>
        </div>
      </div>

      {groups === null ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">{Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-40 rounded-xl" />)}</div>
      ) : groups.length === 0 ? (
        <div className="p-12 text-center rounded-2xl border-2 border-dashed border-slate-200 bg-white">
          <Boxes className="h-10 w-10 mx-auto text-slate-300 mb-3" />
          <p className="text-slate-500">Nenhuma turma atribuída a você ainda.</p>
          <p className="text-slate-400 text-sm mt-1">O administrador pode atribuir turmas ao seu perfil.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {groups.map((g) => (
            <button
              key={g.id}
              data-testid={`prof-group-card-${g.id}`}
              onClick={() => navigate(`/prof/turmas/${g.id}`)}
              className="text-left bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all p-5 group h-full flex flex-col"
            >
              <div className="h-10 w-10 rounded-xl grid place-items-center text-white mb-3" style={{ background: "linear-gradient(135deg,#232D4F,#1E9E2A)" }}>
                <Boxes className="h-5 w-5" />
              </div>
              <h3 className="font-display font-semibold text-slate-800 line-clamp-1">{g.name}</h3>
              {g.acesso === "consulta" && <span className="inline-block mt-1 text-[11px] font-semibold px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">só consulta · {g.instructor_name}</span>}
              {g.description && <p className="text-xs text-slate-400 mt-0.5 line-clamp-1">{g.description}</p>}
              <div className="mt-auto pt-4 w-full">
                <div className="grid grid-cols-3 gap-2 border-t border-slate-100 pt-3.5">
                  {[[Users, g.student_count, "alunos", "text-[#1A2340]"], [null, g.active_count ?? 0, "com curso ativo", "text-[#1E9E2A]"], [BookOpen, g.course_count, "cursos", "text-[#1A2340]"]].map(([Ic, n, rot, cor]) => (
                    <div key={rot}>
                      <div className={`font-display text-xl font-bold leading-none ${cor}`}>{Number(n || 0).toLocaleString("pt-BR")}</div>
                      <div className="mt-1 flex items-center gap-1 text-[11px] text-slate-500">{Ic && <Ic className="h-3 w-3" />}{rot}</div>
                    </div>
                  ))}
                </div>
                <div className="mt-3 flex items-center justify-end gap-1 text-xs font-semibold text-[#232D4F]">Abrir turma <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
